var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_vm._m(0),_c('div',{staticClass:"success__message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success__checkmark"},[_c('div',{staticClass:"check-icon"},[_c('span',{staticClass:"icon-line line-tip"}),_c('span',{staticClass:"icon-line line-long"}),_c('div',{staticClass:"icon-circle"}),_c('div',{staticClass:"icon-fix"})])])
}]

export { render, staticRenderFns }